import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ProductNfceMappingValidationSchema } from '@/features/productNfceMappings/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

interface UseUpdateProductNfceMappingProps {
  productNfceMappingId: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: AxiosError) => void
}

export const useUpdateProductNfceMapping = ({
  productNfceMappingId,
  onSuccess,
  onError,
}: UseUpdateProductNfceMappingProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateProductNfceMapping'],
    mutationFn: async (form: ProductNfceMappingValidationSchema) => {
      const product_nfce_mapping = {
        name: form.name,
        product_id: form.product_id.value,
      }

      return await privateAxios.put(`/product_nfce_mappings/${productNfceMappingId}`, { product_nfce_mapping })
    },
    onSuccess,
    onError,
  })
}
